export const ONBOARDING_LOGIN = 'ONBOARDING_LOGIN';
export const ONBOARDING_SAVE_DATA = 'ONBOARDING_SAVE_DATA';
export const SET_ONBOARDING_PROPERTY = 'SET_ONBOARDING_PROPERTY';
export const ONBOARDING_UPLOAD_DOCUMENT = 'ONBOARDING_UPLOAD_DOCUMENT';
export const ONBOARDING_LEGAL_CONDITIONS = 'ONBOARDING_LEGAL_CONDITIONS';
export const ONBOARDING_APPLIED_CONSENTS = 'ONBOARDING_APPLIED_CONSENTS';
